export const PROFILE_TYPES = Object.freeze({
    ENDPROCESS: 0,
    CURVES: 1,
    ALARMS: 2,
    EVENTS: 3,
    CONTINUOUS: 4,
    RUNNING: 5,
});